console.log('js/lp_inquiry_no_dates.js -> v0.1.0');

$(function() {
	// RADIO BUTTONS
	$('.js-radio-buttons label, .js-radio-buttons .bttn').on('click touch', function() {
		$(this).parents('.js-radio-buttons').find('label, .bttn').removeClass('active');
		$(this).parents('.js-radio-buttons').find('input[type="radio"]').attr('checked', false);
		$(this).addClass('active');
		$(this).find('input[type="radio"]').attr('checked', true).trigger('change');
	});
	$('.js-radio-buttons input[type="radio"]').change( function() {
		$(this).parents('.js-radio-buttons').find('label, .bttn').removeClass('active');
		$(this).parents('label').addClass('active');
		$(this).attr('checked', true).trigger('click');
	});
	$('.js-radio-buttons input[type="radio"]').click( function(e) {
		e.stopPropagation();
	});


	// INQUIRY MODAL
	$('.js-choose-date').click( function(){
		Cookies.set('inquiry_window_clicked_select_dates', 1);
		$('#inquiry_modal').modal('hide');
		$('html, body').stop().animate({scrollTop: $( $('.listing_query_arrival_date') ).offset().top - 50}, 300, function() {$('.listing_query_arrival_date').addClass('animate-highlight')});
		gae('inquiry_modal', 'select_date_button');
		return false;
	});

	$('#inquiry_modal').on('shown', function() {$('.listing_query_arrival_date').removeClass('animate-highlight')});

	// DATEPICKER - START TODAY (for org-dialogs)
	if ( $('.js-datepicker-start-today').length ) {$('.js-datepicker-start-today').datepicker('setDate', new Date())}

	// BUGFIX FOR SELECTING DATES CLEARING NO DATES SELECTION
	const arrivalDateRadios = document.querySelector('.js-show-on-default-date .js-radio-buttons');
	const arrivalWithDate = document.querySelector('#arrival2');
	const arrivalWithDateLabel = document.querySelector('label[for="arrival2"]');
	const arrivalNoDateLabel = document.querySelector('label[for="arrival1"]');
	const inquirySubmit = document.querySelector('#inquiry-query-submit');
	if (arrivalDateRadios && inquirySubmit) {
		inquirySubmit.addEventListener('click', function(event) {
			arrivalWithDate.checked = 'true';
			arrivalWithDateLabel.classList.add('active');
			arrivalNoDateLabel.classList.remove('active');
		});
	}

	// CODE FOR LP_HIDE_NO_DATES
	const availableDates = document.querySelector('.js-show-on-default-date');
	const readOnlyDate = document.querySelector('#listing_query_arrival_date');
	const dateDropdown = document.querySelector('#arrival_date_select option[selected]');
	const modalArrivalNotToday = document.querySelector('.js-show-if-not-today');
	const modalArrivalToday = document.querySelector('.js-hide-if-not-today');
	const modalLinkToday = document.querySelector('.js-hide-link-if-not-today');
	var selectedArrivalDate = "";
	var d = new Date();
	var month = '' + (d.getMonth() + 1);
	var day = '' + d.getDate();
	var year = d.getFullYear();
	if (month.length < 2) {
		month = '0' + month;
	}
	if (day.length < 2) {
		day = '0' + day;
	}
	const formattedTodaysDate = [year, month, day].join('-');

	function getselectedArrivalDate() {
		if (readOnlyDate) {
			selectedArrivalDate = readOnlyDate.value;
		}
		if (dateDropdown) {
			selectedArrivalDate = dateDropdown.value;
		}
		return selectedArrivalDate;
	}

	if (inquirySubmit) {
		inquirySubmit.addEventListener('click', function(event) {
			getselectedArrivalDate();
			if (availableDates) {
				if (selectedArrivalDate > formattedTodaysDate ) {
					modalArrivalNotToday.style.display = 'block';
					modalArrivalToday.style.display = 'none';
					modalLinkToday.style.display = 'none';
				} else {
					modalArrivalNotToday.style.display = 'none';
					modalArrivalToday.style.display = 'flex';
					modalLinkToday.style.display = 'block';
				}
			}
		});
	}

});
